<script>
import SnackbarComponent from '@/components/SnackbarComponent.vue'
import ModalRenderer from '@/components/ui/ModalRenderer.vue'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { handleResponseError } from '@/utils/toastUtils'
import { useAuthStore } from '@/store/authStore'

export default {
  components: { SnackbarComponent, ModalRenderer, AdminLayout },
  computed: {
    layout() {
      return this.$route.meta.layout || 'div'
    },
    loggedIn() {
      return this.authStore.auth.status.loggedIn
    }
  },
  async created() {
    this.authStore = useAuthStore()
    await this.$router.isReady()
    if (this.loggedIn && !this.$route.meta.publicCapability) {
      try {
        await this.authStore.me()
      } catch (error) {
        handleResponseError(error)
      }
    }
  }
}
</script>

<template>
  <component :is="layout">
    <RouterView
      :key="$route.meta.publicCapability ? $route.path + JSON.stringify($route.query) : undefined"
    />
  </component>
  <ModalRenderer />
  <SnackbarComponent />
</template>
